import React from "react";
import { useWindowScroll } from "../../../components/hooks/useWindowScroll";
import { CueSheetsMaintenancePage, ICueSheetsMaintenancePageProps } from "./CueSheetsMaintenancePage";

const CueSheetsMaintenancePageScrollListener: React.FC<ICueSheetsMaintenancePageProps> = (props) => {
    const updatedScroll = useWindowScroll();
    return <CueSheetsMaintenancePage {...props} updatedScroll={updatedScroll} />;
};

export default CueSheetsMaintenancePageScrollListener;
